import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, dovocalRequest } from "../../helper";
import $, { valHooks } from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";

export default class ModiparivarModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "",
      points: 1,
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
      limit: 100,
      page: 1,
      selectedButton: null,
      popupImageUrl: "",
      postDetail: {},
      selectedPostActivity: "",
    };
    this.update = this.update.bind(this);
    this.rejectupdate = this.rejectupdate.bind(this);
    this.getPromoted = this.getPromoted.bind(this);
    this.getGallerydata = this.getGallerydata.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }

  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "1";
    }
    this.getGallerydata("loadmore", this.state.page, status, "");
  }

  getGallerydata(loadmore, pageno, status, point) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });

    if (point == "disable") {
      ref.setState({
        points: 0,
      });
    }
    if (point == "enable") {
      ref.setState({
        points: 1,
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/mehumodiparivar/list?&limit=${
        this.state.limit
      }&page=${
        pageno ? pageno : this.state.page
      }&status=${status}&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && (result.resultFlag === 1 || result.resultFlag === "1")) {
          if (status == "0") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response.response],
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.response.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  getPromoted(loadmore, pageno, status, point, promot) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });
    if (point == "promoted") {
      ref.setState({
        points: 2,
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/mehumodiparivar/list?&limit=${
        this.state.limit
      }&page=${pageno ? pageno : this.state.page}&status=${status}&promoted=${
        promot ? promot : ""
      }&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && (result.resultFlag === 1 || result.resultFlag === "1")) {
          if (status == "0") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response.response],
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.response.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  update(id, status) {
    let confirm = window.confirm(
      "Are you sure you want to promoted this image ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        post_id: id.toString(),
        promoted: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/mehumodiparivar/postupdate",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result && result["resultFlag"] == 1) {
            window.location.reload();
            // $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  rejectupdate(id, status) {
    let confirm = window.confirm(
      "Are you sure you want to disable this image ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        post_id: id.toString(),
        status: status,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/mehumodiparivar/postdelete",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (
            result &&
            (result.resultFlag === 1 || result.resultFlag === "1")
          ) {
            console.log("hello", result);
            $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    $("#loader").css({ display: "block" });
    this.getGallerydata("loadmore", this.state.page + 1, this.state.status);
    $("#loader").css({ display: "none" });
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };

  render() {
    var bread = "Mei Hu Modi Parivar / Moderation (Disabled Posts)";
    var pagelink = "/viksitbharatselfie/moderation";
    if (this.state.status == "0") {
      bread = "Mei Hu Modi Parivar/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (this.state.status == "1") {
      bread = "Mei Hu Modi Parivar/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    } else {
      bread = "Mei Hu Modi Parivar/ Moderation (Enabled Posts)";
      pagelink += "/disabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/meihumodiparivar/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/meihumodiparivar/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;
    return (
      <div>
        <PageTitle
          title="#Mei Hu Modi Parivar"
          bread={bread}
          //   links={links}
          Count={this.state.postCount}
        />
        <div className="wrapper wrapper-content">
          {/* <br /> */}
          <h4>Disclaimer :</h4>
          <div className="form_maindiv">
            <div>
              <div className="form_checkdiv">
                <a
                  href="javascript:void(0);"
                  className="btn btn-primary btn-circle"
                  type="button"
                  title="promoted"
                >
                  <i className="fa fa-check"></i>
                </a>
                <p>Click on this icon to promoted the image.</p>
              </div>
              <div className="form_checkdiv">
                <a
                  href="javascript:void(0);"
                  className="btn btn-warning btn-circle"
                  type="button"
                  title="disable"
                >
                  <i className="fa fa-times"></i>
                </a>
                <p>Click on this icon to disable the image.</p>
              </div>
            </div>

            <div>
              <div className="form-inline form_right">
                <div>
                  <button
                    className={
                      this.state.points === 2
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => this.getPromoted("", 1, 1, "promoted", 1)}
                  >
                    Promoted
                  </button>
                  <button
                    className={
                      this.state.points === 1
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => this.getGallerydata("", 1, 1, "enable", "")}
                  >
                    Enable
                  </button>
                  <button
                    className={
                      this.state.points === 0
                        ? `btn btn-success btn-rounded`
                        : `btn btn-primary btn-rounded`
                    }
                    onClick={() => this.getGallerydata("", 1, 0, "disable", "")}
                  >
                    Disable
                  </button>
                </div>
              </div>
            </div>
          </div>

          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    console.log("value", value.promoted);
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <div className="user_image_list">
                                  <ul>
                                    <li>
                                      <a>
                                        <img src={value.post_url} alt="" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                {/* <div className="image_caption vbactivity"> */}
                                <div className="image_caption vbactivity">
                                  {value.promoted == 0 && (
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-primary btn-circle"
                                      onClick={() => {
                                        this.update(value.id, 1);
                                      }}
                                      type="button"
                                      title="promoted"
                                    >
                                      <i className="fa fa-check"></i>
                                    </a>
                                  )}
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.rejectupdate(value.id, 0);
                                    }}
                                    type="button"
                                    title="disable"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              {value.activity_name ? value.activity_name : ""}
                              <br />

                              <small>
                                Added: {value.created ? value.created : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ModiParivar/Moderation.jsx